import React from 'react';
import { IconCategory } from '@tabler/icons';
import SimpleLookupCrud from '../references/SimpleLookupCrud';

const Categories = () => (
    <SimpleLookupCrud
        icon={IconCategory}
        gradient="blue"
        title="Categorias de Produto"
        subtitle="Organize seu catálogo em categorias (pode ter subcategorias)"
        endpoint="categories"
        addLabel="Nova categoria"
        columns={[
            { key: 'name', label: 'Nome', type: 'text', required: true },
            { key: 'parent', label: 'Categoria pai', type: 'select', optionsSource: 'self' }
        ]}
    />
);

export default Categories;
